import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import InputField from '../../../../../../FormControl/input/InputField';
import SelectMultipleField from '../../../../../../FormControl/input/SelectMultipleField';
import { SelectMultipleFieldFlags } from '../../../../../../FormControl/SelectRequest/SelectMultipleFieldFlags';
import { useSelector } from 'react-redux';

const StudentInformation = ({ form, error, onChange, isLoadingYears, dataYears, errorFetchYears }) => {
  const date = useSelector((state) => state?.date?.date || new Date());

  return (
    <div>
      <Box className='flex flex-col gap-4 bg-primary text-primary-foreground px-2 py-2 rounded-md'>
        <Typography variant='inherit' className='font-bold capitalize' color='primary-foreground'>
          Filter by student information
        </Typography>
      </Box>
      <div className='px-2 py-2 text-primary'>You must select at least 1 element of the student for a quick search.</div>
      <div className='grid grid-cols-3 items-center gap-4 pr-4 pt-2'>
        {/* <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          Code
        </Typography>
        <div className='col-span-2'>
          <InputField
            id='form-filter-code'
            name='code'
            value={form.code}
            error={error.code}
            helperText={error.code}
            maxDate={date}
            onChange={(e) => onChange('code', e.target.value)}
          />
        </div>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          first name
        </Typography>
        <div className='col-span-2'>
          <InputField
            id='form-filter-first-name'
            name='firstName'
            value={form.firstName}
            error={error.firstName}
            helperText={error.firstName}
            maxDate={date}
            onChange={(e) => onChange('firstName', e.target.value)}
          />
        </div>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          last name
        </Typography>
        <div className='col-span-2'>
          <InputField
            id='form-filter-last-name'
            name='lastName'
            value={form.lastName}
            error={error.lastName}
            helperText={error.lastName}
            maxDate={date}
            onChange={(e) => onChange('lastName', e.target.value)}
          />
        </div>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          preferred name
        </Typography>
        <div className='col-span-2'>
          <InputField
            id='form-filter-preferred-name'
            name='preferredName'
            value={form.preferredName}
            error={error.preferredName}
            helperText={error.preferredName}
            onChange={(e) => onChange('preferredName', e.target.value)}
          />
        </div> */}
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          year level
        </Typography>
        <div className='col-span-2'>
          <SelectMultipleField
            id='form-filter-year-level'
            name='yearLevelId'
            value={form.yearLevelId}
            error={error.yearLevelId || errorFetchYears}
            helperText={error.yearLevelId || errorFetchYears}
            onChange={(e) => onChange('yearLevelId', e.target.value)}
            loading={isLoadingYears}
            options={dataYears?.map((item) => ({ value: item._id, label: item.name })) || []}
            placeholder='Choose a year level'
          />
        </div>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          form
        </Typography>
        <div className='col-span-2'>
          <InputField
            id='form-filter-form'
            name='form'
            value={form.form}
            error={error.form}
            helperText={error.form}
            maxDate={date}
            onChange={(e) => onChange('form', e.target.value)}
          />
        </div>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          house
        </Typography>
        <div className='col-span-2'>
          <InputField
            id='form-filter-house'
            name='house'
            value={form.house}
            error={error.house}
            helperText={error.house}
            maxDate={date}
            onChange={(e) => onChange('house', e.target.value)}
          />
        </div>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          flag
        </Typography>
        <div className='col-span-2'>
          <SelectMultipleFieldFlags
            id='form-filter-flag'
            name='flag'
            value={form.flag}
            error={error.flag}
            helperText={error.flag}
            onChange={(e) => onChange('flag', e.target.value)}
            fieldValue='importName'
          />
        </div>
      </div>
    </div>
  );
};

export default StudentInformation;
